// extracted by mini-css-extract-plugin
module.exports = {"leadership__hero":"VideoListing_leadership__hero__X82fB","leaders__listing":"VideoListing_leaders__listing__mQ_LN","leaders":"VideoListing_leaders__NKnQM"};